export default {
    lawServe: {
        Description: {
            title: 'Legal Service',
            module1: {
                title: 'Professional Legal Service Resources',
                btn: 'View Details',
                box1: {
                    title: 'Cross-border Trade & Investment Legal Services',
                    text: 'End-to-end international business legal solutions covering compliance (export controls/antitrust), IP protection, and trade dispute resolution to empower risk management and stable global expansion.',
                },
                box2: {
                    title: 'Overseas Business Complaint Services for Chinese Enterprises',
                    text: 'Provides free cross-border dispute resolution consulting and complaint handling, covering trade friction alerts, anti-commercial fraud guidance, and overseas rights protection to support compliant global business expansion.',
                },
                box3: {
                    title: 'Legal Service Hotline',
                    text: 'Comprehensive public legal services including consultations, service referrals, legal database queries, case research, legal aid, notarization, judicial authentication, and arbitration services.',
                },
            },
            module2: {
                title: 'Local Legal Service Quick Access',
                box1: {
                    text: 'Civil Mediation',
                },
                box2: {
                    text: 'Notarization Services',
                },
                box3: {
                    text: 'Legal Aid',
                },
            },
            module3: {
                title: 'Legal Services for Navigating Complex International Environments',
                text: 'In global trade, agricultural services face multifaceted legal challenges—from cross-border contract execution and IP protection to diverse compliance requirements. Our legal services provide integrated solutions with international legal teams and multi-jurisdictional resources to help clients mitigate risks, protect rights, and resolve disputes efficiently for sustainable global operations.',
                imgBox1: {
                    title: 'Cross-border Contract Review & Drafting',
                    text1: 'Review international procurement, distribution, and investment agreements to ensure compliance with local laws and risk mitigation',
                    text2: 'Multilingual contract templates (CN/EN/ES) with rapid customization'
                },
                imgBox2: {
                    title: 'Global IP Protection',
                    text1: 'International trademark/patent/copyright registration and infringement litigation',
                    text2: 'Global IP monitoring with strategic alerts and recommendations'
                },
                imgBox3: {
                    title: 'International Arbitration & Litigation',
                    text1: 'Representation in cross-border disputes, debt recovery, and anti-dumping cases',
                    text2: 'Direct access to ICC/SIAC arbitration for faster dispute resolution'
                },
                imgBox4: {
                    title: 'Compliance & Regulatory Advisory',
                    text1: 'Guidance on GDPR, export controls and trade compliance requirements',
                    text2: 'Cross-border tax structures to avoid double taxation and compliance risks'
                },
                imgBox5: {
                    title: 'International Trade Agreement Support',
                    text1: 'RCEP/CPTPP analysis for optimized supply chain planning',
                    text2: 'Trade barrier solutions including countervailing/anti-dumping measures'
                },
                imgBox6: {
                    title: 'Legal Risk Management',
                    text1: 'Country-specific risk assessments covering labor, environmental laws etc.',
                    text2: 'Contingency planning for sanctions, customs detentions and emergencies'
                },
            }
        } 
    }
}